






import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Row extends Vue {
  @Prop({ default: '1rem' })
  public readonly gutter!: number;

  @Prop({ default: 'flex-start' })
  public readonly verticalAlign!: string;

  @Prop({ default: 'space-between' })
  public readonly horizontalAlign!: string;
}
